<template>
  <main class="editorial">
    <section class="cards">
      <embedded-video v-for="video in videos" :key="video.id" :video="video" />
    </section>
    <section class="lets-chat">
      <p>Like what you saw?</p>
      <ts-button
        title="LET'S CHAT"
        style="margin-top: 0"
        @click="$router.push('/contact')"
      />
    </section>
  </main>
</template>

<script>
import EmbeddedVideo from "@/components/EmbeddedVideo";
import TSButton from "@/components/TSButton";

export default {
  name: "Editorial",
  components: {
    "embedded-video": EmbeddedVideo,
    "ts-button": TSButton,
  },
  data: function() {
    return {
      videos: [
        {
          id: 50,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/5media_farming_with_trees.jpg",
          description: "5 Media | Farming With Trees",
          title: "5 Media | Farming With Trees",
          link: "https://www.youtube.com/embed/klWTHtjkZ3E",
          size: { height: 900, width: 1600 },
          tags: ["Director", "Producer", "Editor"],
        },
        {
          id: 51,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/5media_waterless_soap.jpg",
          description: "5 Media | Waterless Soap",
          title: "5 Media | Waterless Soap",
          link: "https://www.youtube.com/embed/_z2O_p13aFs",
          size: { height: 900, width: 1600 },
          tags: ["Director", "Producer", "Editor"],
        },
        {
          id: 1,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/ATTN_FEMALE_ENTRPENEURS.jpg",
          description: "ATTN Female entrepreneurs",
          title: "ATTN: | Female Entrepreneurs Fights sexism",
          link:
            "https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Fattnlife%2Fvideos%2F1936072796655060%2F&show_text=0",
          size: { height: 800, width: 800 },
          tags: ["Producer", "Editor"],
        },
        {
          id: 2,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/LAIST_MARCIACHI.jpg",
          description: "LAist Mariachi",
          title: "KPCC/LAist | The Next Generation Of Mariachi",
          link:
            "https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2FtheLAist%2Fvideos%2F280607442530517%2F&show_text=0",
          size: { height: 800, width: 800 },
          tags: ["Producer", "Editor", "Videographer"],
        },
        {
          id: 3,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/attn_children_chores.jpg",
          description: "ATTN: Childhood Chores",
          title: "ATTN: | Childhood Chores ",
          link:
            "https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Fattnlife%2Fvideos%2F1701672136804407%2F&show_text=0",
          size: { height: 900, width: 1600 },
          tags: ["Producer", "Editor"],
        },
        {
          id: 4,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/attn_office-dogs.jpg",
          description: "ATTN: Office Dog",
          title: "ATTN: | It's Time For an Office Dog",
          link:
            "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fattn%2Fvideos%2F1068119166556875%2F&show_text=0",
          size: { height: 900, width: 1600 },
          tags: ["Producer", "Editor"],
        },
        {
          id: 5,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/ATTN_NORTH_KOREA.jpg",
          description: "ABC NEWS North Korea",
          title: "ABC NEWS | China and North Korea – It’s complicated",
          link:
            "https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Fattn%2Fvideos%2F1507844202584367%2F&show_text=0",
          size: { height: 800, width: 800 },
          tags: ["Producer", "Editor"],
        },
        {
          id: 6,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/ATTN_DEMENTIA_VILLAGES.jpg",
          description: "ATTN DEMENTIA VILLAGES",
          title: "ATTN: | Dementia Villages",
          link:
            "https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2FATTNVideo%2Fvideos%2F1488244044544383%2F&show_text=0",
          size: { height: 900, width: 1600 },
          tags: ["Producer", "Editor"],
        },
        {
          id: 7,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/ATTN_UNHEALTHY_FOOD.png",
          description: "ATTN unhealthy food",
          title: "ATTN: | Our Unhealthy Relationships With Food",
          link:
            "https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Fattn%2Fvideos%2F1377624395606349%2F&show_text=0",
          size: { height: 800, width: 800 },
          tags: ["Producer", "Editor"],
        },
        // {
        //   id: 8,
        //   thumbnail: "https://storage.googleapis.com/signelarsenstatics/ATTN_BIG_BOOBS.jpg",
        //   description: "ATTN big boobs",
        //   title: "ATTN: | Big Boobs Deserve Better Bras",
        //   link: 'https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Fattn%2Fvideos%2F1118461961522595%2F&show_text=0',
        //   size: { height: 900, width: 1600 },
        //   tags: ['Producer', 'Editor']
        // },
        {
          id: 9,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/ATTN_HEMP.jpg",
          description: "ATTN hemp",
          title: "ATTN: | The Power of Hemp",
          link:
            "https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Fattn%2Fvideos%2F1171341122901345%2F&show_text=0",
          size: { height: 900, width: 1600 },
          tags: ["Producer", "Editor"],
        },
        {
          id: 10,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/attn_ecovillages.jpg",
          description: "ATTN Ecovillages",
          title: "ATTN: | Ecovillages Are Cool",
          link:
            "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fattn%2Fvideos%2F1234668853235238%2F&show_text=0",
          size: { height: 900, width: 1600 },
          tags: ["Producer", "Editor"],
        },
        {
          id: 11,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/Laist_Sierra_Nevada_Day_1_2.jpg",
          description: "LAist The Sierra Nevada 01",
          title: "LAist | Traveling Alone In The Sierra Nevada: Day 1",
          link: "https://www.youtube.com/embed/V0S7TukFcQ8",
          size: { height: 1680, width: 940 },
          tags: ["Producer", "Editor"],
        },
        {
          id: 12,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/Laist_Sierra_Nevada_Day_2_2.jpg",
          description: "LAist The Sierra Nevada 02",
          title: "LAist | Traveling Alone In The Sierra Nevada: Day 2",
          link: "https://www.youtube.com/embed/-KGXu8xt6AQ",
          size: { height: 1680, width: 940 },
          tags: ["Producer", "Editor"],
        },
        {
          id: 13,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/Laist_Sierra_Nevada_Day_7_2.jpg",
          description: "LAist The Sierra Nevada 07",
          title: "LAist | Traveling Alone In The Sierra Nevada: Day 7",
          link: "https://www.youtube.com/embed/PzqP5kdUl1M",
          size: { height: 1680, width: 940 },
          tags: ["Producer", "Editor"],
        },
        {
          id: 14,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/Laist_Sierra_Nevada_Day_14_2.jpg",
          description: "LAist The Sierra Nevada 14",
          title: "LAist | Traveling Alone In The Sierra Nevada: Day 14",
          link: "https://www.youtube.com/embed/ld_Y-8LgkZM",
          size: { height: 1680, width: 940 },
          tags: ["Producer", "Editor"],
        },
        {
          id: 15,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/ATTN_SILVERMAN.png",
          description: "ATTN Sarah Silverman",
          title: "ATTN: | Sarah Silverman on Male Masturbation",
          link:
            "https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Fattn%2Fvideos%2F1396401330395322%2F&show_text=0",
          size: { height: 800, width: 800 },
          tags: ["Producer", "Editor"],
        },
        {
          id: 16,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/laist_martinstarr_02.jpg",
          description: "LAist Martin Starr",
          title: "LAist | Martin Starr Wants LAist Back",
          link:
            "https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2FtheLAist%2Fvideos%2F10156768263855649%2F&show_text=0",
          size: { height: 800, width: 800 },
          tags: ["Producer", "Editor"],
        },
        // {
        //   id: 17,
        //   thumbnail: "https://storage.googleapis.com/signelarsenstatics/attn_nudity.jpg",
        //   description: "ATTN Nudity Hypocrisy",
        //   title: "ATTN: | Society's Hypocrisy Toward Nudity",
        //   link: 'https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fattn%2Fvideos%2F1243458525689604%2F&show_text=0',
        //   size: { height: 900, width: 1600 },
        //   tags: ['Producer', 'Editor']
        // },
        {
          id: 18,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/ATTN_BREASTFEEDING.jpg",
          description: "ATTN breast feeding",
          title: "ATTN: | Not All Moms Can Breastfeed",
          link:
            "https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Fattn%2Fvideos%2F1304186349616821%2F&show_text=0",
          size: { height: 900, width: 1600 },
          tags: ["Editor"],
        },
        {
          id: 19,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/kpcc_fire-building_02.jpg",
          description: "KPCC Building in Fire-Prone Areas",
          title: "KPCC | Building in Fire-Prone Areas",
          link:
            "https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Fkpcc%2Fvideos%2F529573244153790%2F&show_text=0",
          size: { height: 800, width: 800 },
          tags: ["Producer", "Editor", "Videographer"],
        },
        {
          id: 20,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/ATTN_AMERCIA_VS_PROCESSED_FOOD.jpg",
          description: "ATTN Processed Food",
          title: "ATTN: | Processed Food America Vs.",
          link:
            "https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2FATTNVideo%2Fvideos%2F1321760117859444%2F&show_text=0",
          size: { height: 900, width: 1600 },
          tags: ["Producer", "Editor"],
        },
        {
          id: 21,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/attn_NFL_player_marijuana.jpg",
          description: "ATTN: NFL Player Deserve Medical Marijuana",
          title: "ATTN: | NFL Player Deserve Medical Marijuana",
          link:
            "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fattn%2Fvideos%2F1294572563911533%2F&show_text=0",
          size: { height: 900, width: 1600 },
          tags: ["Producer", "Editor"],
        },
        {
          id: 22,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/ATTN_MIKE_ROWE.jpg",
          description: "ATTN Mike Rowe",
          title: "ATTN: | Mike Rowe on Expensive Colleges",
          link:
            "https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Fattn%2Fvideos%2F1466464693388985%2F&show_text=0",
          size: { height: 800, width: 800 },
          tags: ["Producer", "Editor"],
        },
        {
          id: 23,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/LAIST_BRING_BACK.png",
          description: "Bring Back LAist",
          title: "LAist | Bring Back LAist",
          link:
            "https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2FtheLAist%2Fvideos%2F10156742072685649%2F&show_text=0",
          size: { height: 800, width: 800 },
          tags: ["Producer", "Editor", "Videographer"],
        },
        // {
        //   id: 24,
        //   thumbnail: "https://storage.googleapis.com/signelarsenstatics/ATTN_GERMS.jpg",
        //   description: "ATTN Germs",
        //   title: "ATTN: | Airplanes Are Covered in Germs",
        //   link: 'https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2FATTNVideo%2Fvideos%2F1625834151054873%2F&show_text=0',
        //   size: { height: 900, width: 1600 },
        //   tags: ['Producer', 'Editor']
        // },
        {
          id: 25,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/ATTN_KIDS_TIME_OUTDOOR.jpg",
          description: "ATTN outdoor",
          title: "ATTN: | Childhood in America Vs. in Europe",
          link:
            "https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Fattn%2Fvideos%2F1009495832419209%2F&show_text=0",
          size: { height: 900, width: 1600 },
          tags: ["Producer", "Editor"],
        },
        {
          id: 26,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/kpcc_house_prices.jpg",
          description: "KPCC California Real Estate",
          title: "KPCC | Buying Real Estate in California",
          link:
            "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fkpcc%2Fvideos%2F10155639605378016%2F&show_text=0",
          size: { height: 900, width: 1600 },
          tags: ["Producer", "Editor", "Videographer"],
        },
        {
          id: 27,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/laist_chubbs-02.jpg",
          description: "LAist Chubbs",
          title: "LAist | Chubbs Has a New Home",
          link:
            "https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2FtheLAist%2Fvideos%2F10156822360530649%2F&show_text=0",
          size: { height: 800, width: 800 },
          tags: ["Producer", "Editor"],
        },
        {
          id: 28,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/attn_electric_cars_norway.jpg",
          description: "ATTN: Electric Cars",
          title: "ATTN: | Electric Cars in Norway",
          link:
            "https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Fattn%2Fvideos%2F1343675249001264%2F&show_text=0",
          size: { height: 800, width: 800 },
          tags: ["Producer", "Editor"],
        },
        {
          id: 29,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/attn_denmark_college.jpg",
          description: "ATTN: College Costs in Denmark",
          title: "ATTN: | College Costs in Denmark",
          link:
            "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fattn%2Fvideos%2F1127841850584606%2F&show_text=0",
          size: { height: 900, width: 1600 },
          tags: ["Producer", "Editor"],
        },
        {
          id: 30,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/attn_recycling_taiwan_02.jpg",
          description: "ATTN: Recycling in Taiwan",
          title: "ATTN: | Recycling in Taiwan vs in Ameria",
          link:
            "https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Fattn%2Fvideos%2F1317437041625085%2F&show_text=0",
          size: { height: 800, width: 800 },
          tags: ["Producer", "Editor"],
        },
        {
          id: 31,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/lelepons_venezuela_02.jpg",
          description: "ATTN: Lele Pons",
          title: "ATTN: | Lele Pons on the Crisis in Venezuela",
          link:
            "https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Fattn%2Fvideos%2F1478027392232715%2F&show_text=0",
          size: { height: 800, width: 800 },
          tags: ["Editor"],
        },
        {
          id: 32,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/attn_winter_swimming.jpg",
          description: "ATTN: Winter Swimming",
          title: "ATTN: | Swimming in Freezing Water",
          link:
            "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2FATTNVideo%2Fvideos%2F1651584321813189%2F&show_text=0",
          size: { height: 900, width: 1600 },
          tags: ["Producer", "Editor"],
        },
        {
          id: 33,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/attn_birth_control_legalization_03.jpg",
          description: "ATTN: Birth Control",
          title: "ATTN: | The Legalization of Birth Control",
          link:
            "https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Fattn%2Fvideos%2F1534997286535725%2F&show_text=0",
          size: { height: 800, width: 800 },
          tags: ["Editor"],
        },
        {
          id: 34,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/attn_shop_class.jpg",
          description: "ATTN: Shop class",
          title: "ATTN: Bring Back Shop class",
          link:
            "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fattn%2Fvideos%2F1224900267545430%2F&show_text=0",
          size: { height: 900, width: 1600 },
          tags: ["Producer", "Editor"],
        },
        {
          id: 35,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/attn_mansplaining.jpg",
          description: "ATTN:  Stop Mansplaining",
          title: "ATTN: | Stop Mansplaining",
          link:
            "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fattn%2Fvideos%2F1051065834928875%2F&show_text=0",
          size: { height: 900, width: 1600 },
          tags: ["Producer", "Editor"],
        },
        {
          id: 36,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/attn_miscarriages_taboo.jpg",
          description: "ATTN: Miscarriages",
          title: "ATTN: | The Truth Around Miscarriages",
          link:
            "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fattn%2Fvideos%2F1197429313625859%2F&show_text=0",
          size: { height: 900, width: 1600 },
          tags: ["Producer", "Editor"],
        },
        {
          id: 37,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/attn_women_calling_crazy.jpg",
          description: "ATTN: Crazy Women",
          title: "ATTN: | Stop Calling Women Emotional",
          link:
            "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fattn%2Fvideos%2F1068596136509178%2F&show_text=0",
          size: { height: 900, width: 1600 },
          tags: ["Producer", "Editor"],
        },
        {
          id: 38,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/attn_muscle_women.jpg",
          description: "ATTN: Muscular Women",
          title: "ATTN: | Muscle Shaming",
          link:
            "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fattn%2Fvideos%2F1033989579969834%2F&show_text=0",
          size: { height: 900, width: 1600 },
          tags: ["Producer", "Editor"],
        },
        {
          id: 39,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/attn_pink_tax.jpg",
          description: "ATTN: The Pink Tax",
          title: "ATTN: | The Pink Tax",
          link:
            "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fattn%2Fvideos%2F980905895278203%2F&show_text=0",
          size: { height: 900, width: 1600 },
          tags: ["Producer", "Editor"],
        },
        {
          id: 40,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/attn_native_americans_respect.jpg",
          description: "ATTN: Native Americans",
          title: "ATTN: | Native Americans Deserve Our Respect",
          link:
            "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2FATTNVideo%2Fvideos%2F1617694488535506%2F&show_text=0",
          size: { height: 900, width: 1600 },
          tags: ["Producer", "Editor"],
        },
        {
          id: 41,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/attn_voting_america_vs.jpg",
          description: "ATTN: Voting",
          title: "ATTN: | Voting in Sweden Vs. America",
          link:
            "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fattn%2Fvideos%2F1136948059673985%2F&show_text=0",
          size: { height: 900, width: 1600 },
          tags: ["Producer", "Editor"],
        },
        {
          id: 42,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/attn_infertility.jpg",
          description: "ATTN: Infertility Stories",
          title: "ATTN: | Infertility Stories",
          link:
            "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2FFox8NewsCleveland%2Fvideos%2F1714214432216844%2F&show_text=0",
          size: { height: 900, width: 1600 },
          tags: ["Producer", "Editor"],
        },
        {
          id: 43,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/attn_abuse_survivors_tattoos.jpg",
          description: "ATTN: Tattoo Artist Helps Abuse Survivors",
          title: "ATTN: | Tattoo Artist Helps Abuse Survivors",
          link:
            "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fattn%2Fvideos%2F1282692811766175%2F&show_text=0",
          size: { height: 900, width: 1600 },
          tags: ["Producer", "Editor"],
        },
        {
          id: 44,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/attn_women_politics.jpeg",
          description: "ATTN: Wendy Davis",
          title: "ATTN: | Wendy Davis on Running for Office",
          link:
            "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fattn%2Fvideos%2F1174457832589674%2F&show_text=0",
          size: { height: 900, width: 1600 },
          tags: ["Producer", "Editor"],
        },
        // {
        //   id: 45,
        //   thumbnail: "https://storage.googleapis.com/signelarsenstatics/attn_history_pools_02.jpg",
        //   description: "ATTN: US Pools",
        //   title: "ATTN: | The Racist History of America's Swimming Pools",
        //   link: "https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Ffox13newsutah%2Fvideos%2F1742031726101781%2F&show_text=0",
        //   size: { height: 800, width: 800 },
        //   tags: ['Producer', 'Editor']
        // },
        {
          id: 46,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/attn_dj_khaled-02.jpg",
          description: "ATTN: DJ Khaled ",
          title: "ATTN: | DJ Khaled on Disaster Relief",
          link:
            "https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2FATTNVideo%2Fvideos%2F1758368111134809%2F&show_text=0",
          size: { height: 800, width: 800 },
          tags: ["Editor"],
        },
        {
          id: 47,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/ATTN_AMERICA_VS_RECYCLING.jpg",
          description: "ATTN: Recycling America Vs. in Taiwan",
          title: "ATTN: | Recycling in America Vs. in Taiwan",
          link:
            "https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Fattn%2Fvideos%2F1470915936277194%2F&show_text=0",
          size: { height: 800, width: 800 },
          tags: ["Producer", "Editor"],
        },
        {
          id: 48,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/attn_kids_cooking.jpg",
          description: "ATTN: Why Kids Should Cook",
          title: "ATTN: | Why Kids Should Cook",
          link:
            "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2FATTNVideo%2Fvideos%2F1622138221424466%2F&show_text=0",
          size: { height: 900, width: 1600 },
          tags: ["Producer", "Editor"],
        },
        {
          id: 49,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/attn_chivalry.jpg",
          description: "ATTN: The Debate About Chivalry",
          title: "ATTN: | The Debate About Chivalry",
          link:
            "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fattn%2Fvideos%2F1041457745889684%2F&show_text=0",
          size: { height: 900, width: 1600 },
          tags: ["Producer", "Editor"],
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.editorial {
  display: grid;
  grid-template-columns: 1fr repeat(12, auto) 1fr;
  grid-gap: 40px;
  padding: 60px 0;
}
.cards {
  grid-column: 2 / span 12;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-gap: 40px;
}
.lets-chat {
  grid-column: 2 / span 12;
}
@media only screen and (max-width: 700px) {
  .editorial {
    grid-gap: 20px;
  }
}
@media only screen and (max-width: 500px) {
  .editorial {
    grid-template-columns: 10px repeat(6, 1fr) 10px;
    grid-gap: 10px;
  }
  .cards {
    grid-column: 2 / span 6;
    grid-template-columns: repeat(6, 1fr);
    grid-gap: 20px;
  }
}
</style>
